module.exports = __webpack_public_path__ + "static/img/9.1e1e306.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/eng/9.png
// module id = /Y/B
// module chunks = 0